export const pillSelectSx = {
  height: '100%',
  '& .MuiSelect-select': {
    px: '8px',
    py: 0,
    display: 'flex',
    alignItems: 'center',
    fontSize: '13px',
    minHeight: 'unset !important',
  },
  '& .MuiSelect-icon': {
    right: '2px',
    color: 'text.secondary',
    fontSize: '18px',
  },
};

export const pillTextFieldSx = {
  '& .MuiInputBase-root': {
    height: '100%',
    fontSize: '13px',
  },
  '& .MuiInputBase-input': {
    px: '8px',
    py: 0,
    fontSize: '13px',
  },
  '& fieldset': { border: 'none' },
};

export const segmentDivider = {
  borderRightWidth: 1,
  borderRightStyle: 'solid' as const,
  borderRightColor: 'grey.300',
};
